import Link from 'next/link';

import classNames from 'classnames';

import { socialMediaLinks } from '@/common/constants/footer/links.constant';

interface SocialLinksProps {
  className?: string;
}

const SocialMediaLinks = ({ className }: SocialLinksProps) => {
  return (
    <div
      className={classNames('flex justify-end items-center gap-2.5', className)}
    >
      {socialMediaLinks.map((item, index) => (
        <Link
          key={index}
          href={item.link}
          className="bg-silver w-8 h-8 rounded-sm flex justify-center items-center"
        >
          {item.icon}
        </Link>
      ))}
    </div>
  );
};

export default SocialMediaLinks;
